import { CreateUIAnalyticsEvent } from "@atlaskit/analytics-next";

import { ConfirmationPageType } from "../hooks/use-confirmation-page-type";

export const trackPerceivedProvisioningEvent = ({
    createAnalyticsEvent,
    productKey,
    finalProvisioningScreen,
    actionSubject = "perceivedProvisioningScreen",
    startTimeSeconds = Date.now() / 1000
}: {
    createAnalyticsEvent: CreateUIAnalyticsEvent;
    productKey?: string;
    finalProvisioningScreen?: ConfirmationPageType;
    actionSubject?: string;
    startTimeSeconds?: number;
}) => {
    try {
        const startTime = startTimeSeconds;
        const endTime = Date.now() / 1000;
        const timeSpentSeconds = Math.round(endTime - startTime);

        // if percieved provisioning greater than 20mins throw error
        if (timeSpentSeconds > 1200) {
            throw new RangeError(
                "Perceived provisioning time is greater than 20 minutes"
            );
        }

        // clear sessionStorage before analytics event fire
        sessionStorage.removeItem("startTime");

        createAnalyticsEvent({
            eventType: "track",
            action: "viewed",
            actionSubject,
            attributes: {
                startTimeSeconds: startTime,
                endTimeSeconds: endTime,
                timeSpentSeconds,
                productKey,
                finalProvisioningScreen
            },
            containerId: "perceivedProvisioningPage"
        }).fire();
    } catch (error) {
        // TODO: fire UFO event that perceived provisioning time > 20mins
        console.error("trackEvent:", error);
    }
};

export const trackGetProvisioningStatusLatencyEvent = ({
    createAnalyticsEvent,
    productKey,
    provisioningScreenOnComplete,
    fetchType = "polling",
    startTimeSeconds = Date.now() / 1000,
    elapsedTimeSeconds,
    workflowId
}: {
    createAnalyticsEvent: CreateUIAnalyticsEvent;
    productKey?: string;
    fetchType?: "polling" | "graphql-webhook";
    provisioningScreenOnComplete?: ConfirmationPageType;
    startTimeSeconds?: number;
    elapsedTimeSeconds?: number;
    workflowId: string;
}) => {
    if (!elapsedTimeSeconds) {
        const startTime = startTimeSeconds;
        const endTime = Date.now() / 1000;
        elapsedTimeSeconds = Math.round(endTime - startTime);
    }

    try {
        createAnalyticsEvent({
            eventType: "track",
            action: "loaded",
            actionSubject: "getProvisioningStatusLatency",
            attributes: {
                elapsedTimeSeconds,
                productKey,
                provisioningScreenOnComplete,
                fetchType,
                workflowId
            },
            containerId: "perceivedProvisioningPage"
        }).fire();
    } catch (error) {
        console.error("trackEvent:", error);
    }
};
